import { j as o } from "../jsx-runtime-DywqP_6a.js";
import { ShieldAlertIcon as u, AlertTriangleIcon as k, InfoIcon as l, LightbulbIcon as m } from "lucide-react";
import { c as t } from "../cn-dYga0KKN.js";
const y = {
  note: {
    border: "border-gray-300 dark:border-zinc-800",
    bg: "bg-gray-100 dark:bg-zinc-800/50",
    iconColor: "text-gray-600 dark:text-zinc-300",
    titleColor: "text-gray-600 dark:text-zinc-300",
    textColor: "text-gray-600 dark:text-zinc-300",
    Icon: l
  },
  tip: {
    border: "border-green-500 dark:border-green-800",
    bg: "bg-green-200/25 dark:bg-green-950/70",
    iconColor: "text-green-600 dark:text-green-200",
    titleColor: "text-green-700 dark:text-green-200",
    textColor: "text-green-600 dark:text-green-50",
    Icon: m
  },
  info: {
    border: "border-blue-400 dark:border-blue-900/60",
    bg: "bg-blue-50 dark:bg-blue-950/40",
    iconColor: "text-blue-400 dark:text-blue-200",
    titleColor: "text-blue-700 dark:text-blue-200",
    textColor: "text-blue-600 dark:text-blue-100",
    Icon: l
  },
  caution: {
    border: "border-yellow-400 dark:border-yellow-400/25",
    bg: "bg-yellow-100/60 dark:bg-yellow-400/10",
    iconColor: "text-yellow-500 dark:text-yellow-300",
    titleColor: "text-yellow-600 dark:text-yellow-300",
    textColor: "text-yellow-700 dark:text-yellow-200",
    Icon: k
  },
  danger: {
    border: "border-rose-400 dark:border-rose-800",
    bg: "bg-rose-50 dark:bg-rose-950/40",
    iconColor: "text-rose-400 dark:text-rose-300",
    titleColor: "text-rose-800 dark:text-rose-300",
    textColor: "text-rose-700 dark:text-rose-100",
    Icon: u
  }
}, w = ({
  type: d,
  children: a,
  title: e,
  className: n,
  icon: r = !0
}) => {
  const { border: b, bg: s, iconColor: x, titleColor: i, textColor: c, Icon: g } = y[d];
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: t(
        "not-prose rounded-md border p-4 text-md my-2",
        r && "grid grid-cols-[min-content_1fr] items-baseline grid-rows-[fit-content_1fr] gap-x-4 gap-y-2",
        !r && e && "flex flex-col gap-2",
        "[&_a]:underline [&_a]:decoration-current [&_a]:decoration-from-font [&_a]:underline-offset-4 hover:[&_a]:decoration-1",
        "[&_.code-block-wrapper]:border",
        "[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:ps-4 [&_ul>li]:ps-1 [&_ul>li]:my-1",
        r && e && "items-center",
        b,
        s,
        n
      ),
      children: [
        r && /* @__PURE__ */ o.jsx(
          g,
          {
            className: t(e ? "align-middle" : "translate-y-1", x),
            size: 20,
            "aria-hidden": "true"
          }
        ),
        e && /* @__PURE__ */ o.jsx("h3", { className: t("font-medium", i), children: e }),
        /* @__PURE__ */ o.jsx(
          "div",
          {
            className: t(
              r && "col-start-2",
              !e && r && "row-start-1",
              c,
              "overflow-x-auto"
            ),
            children: a
          }
        )
      ]
    }
  );
};
export {
  w as Callout
};
//# sourceMappingURL=Callout.js.map
